import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { logOut } from "./helpers/utils";

const DEVTOOLS_THRESHOLD = 160;

const isDevToolsOpen = () => {
  return (
    window.outerWidth - window.innerWidth > DEVTOOLS_THRESHOLD ||
    window.outerHeight - window.innerHeight > DEVTOOLS_THRESHOLD
  );
};

const logoutUser = () => {
  // 🔥 Clear auth tokens (adjust to your app)
  localStorage.clear();
  sessionStorage.clear();

  // Example: clear cookie (if any)
  document.cookie
    .split(";")
    .forEach(c => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
    });
};

export default function DevToolsLogoutGuard() {
  const overlayRef = useRef(null);
  const triggeredRef = useRef(false);
   const navigate = useNavigate()

  useEffect(() => {
    const showLogoutScreen = () => {
      if (triggeredRef.current) return;
      triggeredRef.current = true;

      logoutUser();
 logOut(navigate)
      const overlay = document.createElement("div");
      overlay.style.cssText = `
        position: fixed;
        inset: 0;
        background: #020617;
        color: #fff;
        z-index: 999999;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-family: system-ui;
        text-align: center;
      `;

      overlay.innerHTML = `
        <h2 style="margin-bottom:12px;">🚫 Session Ended</h2>
        <p style="max-width:420px; opacity:.85;">
          Developer tools were detected. For security reasons, your session has been terminated.
        </p>
        <button
          id="reload-btn"
          style="
            margin-top:20px;
            padding:10px 20px;
            border-radius:6px;
            border:none;
            cursor:pointer;
            background:#ef4444;
            color:#fff;
            font-weight:600;
          "
        >
          Refresh / Login Again
        </button>
      `;

      document.body.innerHTML = "";
      document.body.appendChild(overlay);
      overlayRef.current = overlay;

      document
        .getElementById("reload-btn")
        ?.addEventListener("click", () => {
            // logOut(navigate)
          window.location.replace(window.location.origin);
        });
    };

    const checkDevTools = () => {
      if (isDevToolsOpen()) {
        showLogoutScreen();
      }
    };

    checkDevTools();
    window.addEventListener("resize", checkDevTools);

    return () => {
      window.removeEventListener("resize", checkDevTools);
    };
  }, []);

  return null;
}
